import React from 'react';
import useStyles from 'apps/Pdf/components/common/styles/PageBreak';

const PageBreak = () => {
  const classes = useStyles();
  return <div className={`pageBreak ${classes.root}`}>&nbsp;</div>;
};

export default PageBreak;
